/* ADE-HOME: Sprach-/Länderauswahl (Topbar, Footer) per Maus bedienbar machen.
   Concept öffnet das Menü beim Überfahren des Buttons, schließt es aber schon beim Verlassen des Buttons –
   also auf dem Weg ins Menü – und ein Klick schließt das per Hover geöffnete Menü sofort wieder.
   Hier: Schließen erst, wenn die Maus Button UND Menü verlässt (kurze Verzögerung); Mausklick auf den Button
   lässt ein offenes Menü offen. Tastatur und Touch bleiben unverändert. Eingebunden über snippets/ade-head.liquid. */
(() => {
  if (window.adeLocalizationInit) return;
  window.adeLocalizationInit = true;

  const isTouch = () => !!(window.theme && theme.config && theme.config.isTouch);

  function fix(dd) {
    if (dd.dataset.adeHover || !dd.detectHoverListener) return;
    dd.dataset.adeHover = '1';
    const item = dd.parentElement;
    if (!item) return;
    let timer;
    (dd.controls || []).forEach((btn) => {
      btn.removeEventListener('mouseleave', dd.detectHoverListener);
      btn.addEventListener('click', (event) => {
        if (!isTouch() && event.detail > 0 && dd.open) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    });
    item.addEventListener('mouseenter', () => clearTimeout(timer));
    item.addEventListener('mouseleave', () => {
      if (isTouch()) return;
      clearTimeout(timer);
      timer = setTimeout(() => { if (dd.open) dd.hide(); }, 250);
    });
  }

  const run = () => document.querySelectorAll('dropdown-localization').forEach(fix);
  if (window.customElements) customElements.whenDefined('dropdown-localization').then(run);
  document.addEventListener('shopify:section:load', run);
})();
